import { ComponentRendering } from '@sitecore-jss/sitecore-jss-react';
import { TField, TImageField, TLinkField, TSitecoreContext, TStringField } from '../../../types/sitecore.types';
import { LinkField, VideoSitecoreField, IField, DropdownSelect, THeadingTag } from '../../../types/types';
import { CardModel } from '../components/card/models/card.models';
import { SplitModuleProps } from '../../splitModule/types/splitModule.types';

export enum ColumnLayoutEnum {
  TwoColumnLayout = '2ColumnLayout',
  ThreeColumnLayout = '3ColumnLayout',
  FourColumnLayout = '4ColumnLayout',
}

export enum ColumnLayoutCardColCountEnum {
  '2ColumnLayout' = 2,
  '3ColumnLayout' = 3,
  '4ColumnLayout' = 4,
}

export type TColumnLayout = {
  name: string;
  fields: {
    Key: {
      value: string | ColumnLayoutEnum;
    };
  };
};

export type TCardButtonProps = {
  model?: CardModel;
  cta1?: TLinkField;
  cta2?: TLinkField;
  downloadButtonLink?: TLinkField;
  primaryctaColor?: string;
  secondaryctaColor?: string;
  validcta2Exists?: boolean;
  validDownloadExists?: boolean;
  cta2Click?: () => void;
  handleSplitModuleModal?: (state: boolean) => void;
  splitModuleLabel?;
  showPopupWithSplitModule?: boolean;
};

export type TIconCardProps = {
  model?: CardModel;
  isEE?: boolean;
  cardHeadingTag?: THeadingTag;
  textcolor?: string;
  primarycta?: string;
  secondarycta?: string;
  showInMobile?: boolean;
  sitecoreContext?: TSitecoreContext;
};

export type TImageCardProps = {
  model: CardModel;
  isEE?: boolean;
  cardHeadingTag?: THeadingTag;
  textcolor?: string;
  layout?: string;
  primarycta?: string;
  secondarycta?: string;
};

export type TCardProps = {
  card: TCardItem;
  layout?: string | ColumnLayoutEnum;
  textcolor?: string;
  primarycta?: string;
  secondarycta?: string;
  cardHeadingTag?: THeadingTag;
  showInMobile?: boolean;
  isEE?: boolean;
};

export type TCardAnimProps = {
  shouldAnimate?: boolean;
  animationDeleyInMs?: number;
};

export type TIconProps = {
  fields?: {
    iconKey?: TStringField;
  };
};

export type TCard = {
  cardCtaTextLink?: LinkField;
  cardSubheading?: TStringField;
  cardHeading?: TStringField;
  cardCtaButton?: LinkField;
  downloadButtonLink?: LinkField;
  image?: TImageField;
  mobileImage?: TImageField;
  icon?: TIconProps;
  video?: VideoSitecoreField;
  useVideo?: IField<boolean>;
  items: Array<TSplitModulePopup>;
};

export type TSplitModulePopup = {
  fields: {
    popUpLabel: {
      value: string;
    };
    items: Array<SplitModuleProps>;
  };
};

export type TCardItem = {
  fields: TCard;
  id: string;
};

export type TCardColumnLayoutFields = {
  sectionEyebrow?: TStringField;
  sectionHeading?: TStringField;
  sectionSubheading?: TStringField;
  sectionCtaTextLink?: LinkField;
  columnLayout?: TColumnLayout;
  items?: TCardItem[];
  componentBgColor?: DropdownSelect;
  textElementColor?: DropdownSelect;
  primaryCtaStyle?: DropdownSelect;
  secondaryCtaStyle?: DropdownSelect;
  totalCardsCount?: number;
  rowsPerPage?: TStringField;
  hideLabelIndicator?: TField<boolean>;
  hideUiLineIndicator?: TField<boolean>;
  showInMobile?: TField<boolean>;
  dataSource?: string;
  isComponentUnreleased: boolean;
};

export type TCardColumnLayoutParams = {
  headingTag?: THeadingTag;
};

export type TCardColumnLayoutProps = {
  fields?: TCardColumnLayoutFields;
  rendering?: ComponentRendering;
  sitecoreContext?: TSitecoreContext;
  params?: TCardColumnLayoutParams;
};

export type TRenderGenericPopup = {
  rendering?: ComponentRendering;
  isEE: boolean;
};
